"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const videotronContents: ReactNode = (
  <>
    <h2 className="text-2xl font-black mb-6 text-center text-blue-700">Sewa Videotron Terdekat Harga Fleksibel, Kualitas Maksimal</h2>
    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Butuh Videotron Sekarang? Ini Solusinya</h2>
      <p className="text-sm leading-relaxed">
        Gak perlu bingung lagi cari <strong>sewa videotron terdekat</strong> yang cepat, murah, dan terpercaya. Kami sediakan videotron P2.5, P3, P4, hingga P10 cocok untuk konser, wedding, pameran, seminar, hingga kampanye. Tinggal pilih
        ukuran, tentukan lokasi, dan tim kami langsung action di hari yang sama.
      </p>
    </section>
    <section className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
      <div className="bg-white p-5 border rounded-xl shadow">
        <h3 className="text-lg font-semibold mb-2">Kenapa Harus Sewa Videotron Terdekat?</h3>
        <ul className="list-disc list-inside text-sm space-y-1">
          <li>Resolusi tinggi (HD hingga 4K) dengan refresh rate 1920Hz+</li>
          <li>Anti silau, tetap jelas meski siang hari</li>
          <li>Modular, cocok untuk booth, panggung, atau backdrop</li>
          <li>Harga sewa fleksibel, mulai dari 3 jam hingga langganan mingguan</li>
          <li>Gratis instalasi dan teknisi standby saat acara</li>
        </ul>
      </div>
      <div className="bg-white p-5 border rounded-xl shadow">
        <h3 className="text-lg font-semibold mb-2">Spesifikasi Videotron Populer</h3>
        <p className="text-sm">
          Banyak klien pilih sewa videotron P3 outdoor untuk kampanye & konser. Untuk event indoor, tipe P2.5 LED NovaStar paling favorit. Panel kami support brightness 6000 7500 nits dan koneksi HDMI/SDI.
        </p>
      </div>
    </section>
    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Harga Sewa Videotron Terdekat 2025</h2>
      <p className="text-sm">
        Harga sewa videotron mulai dari Rp1.5 juta untuk paket 3 jam (P4 outdoor). Untuk paket wedding indoor (8 jam P2.5), harga mulai Rp3.2 juta. Area Jabodetabek, Bandung, Semarang, Surabaya bisa kami layani langsung hari itu juga.
      </p>
      <p className="text-sm mt-2">
        Ingin hemat? Booking 3 hari sebelum acara dan dapatkan <strong>diskon 15%</strong>. Untuk info lengkap klik <a href="/harga-videotron" className="text-blue-600 underline">harga sewa videotron terdekat</a>.
      </p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-bold mb-2">Event Apa Saja yang Cocok?</h2>
      <ul className="list-disc list-inside text-sm space-y-1">
        <li>Sewa videotron outdoor konser malam</li>
        <li>Backdrop nikahan garden party</li>
        <li>Display LED screen kampanye politik</li>
        <li>Pameran properti & otomotif</li>
        <li>Live streaming & hybrid event</li>
      </ul>
    </section>
    <section className="bg-green-50 p-6 rounded-2xl border border-green-200 mb-8">
      <h2 className="text-xl font-bold text-green-700 mb-2">Booking Hari Ini, Pasang Besok</h2>
      <p className="text-sm">
        Slot terbatas setiap pekan. Banyak yang bilang, Kenapa gak dari dulu sewa di sini aja? Hemat waktu, hemat biaya, dan tampil maksimal. <strong>Sewa videotron terdekat</strong> yang benar-benar dekat, bukan janji.
      </p>
      <button className="mt-4 bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
      title="Booking videotron terdekat sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20videotron.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
      >Cek Ketersediaan Sekarang</button>
    </section>
    <section className="text-sm italic text-center"><p>Kalau bisa tampil lebih besar, kenapa harus tampil biasa? tagline kami sejak 2012.</p></section>

    <CTA
      title="Siap Ngiklan Di Layar Super Gede Bosku?"
      description="🚚 Butuh sewa videotron terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Videotron Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20videotron.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Videotron"
    />
  </>
);
